<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-app id="inspire">
      <v-layout wrap justify-center>
        <v-flex xs12 sm6 md4 lg4 px-2 align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs112 xl10>
              <SnackBar
                v-bind:msg="msg"
                v-bind:showSnackBar="showSnackBar"
                @stepper="showSnackBar = false"
              />
              <v-card tile>
                <v-layout wrap justify-center>
                  <v-flex xs12 px-8 pt-12>
                    <v-layout wrap justify-center>
                      <!-- <v-flex xs12 py-4>
                        <v-img
                          src="./../../assets/Images/agogo.png"
                          height="70px"
                          contain
                        ></v-img>
                      </v-flex> -->
                      <v-flex xs12 pt-4>
                        <span
                          style="
                            font-family: poppinsmedium;
                            font-size: 18px;
                            color: #090909;
                          "
                          >OTP Verification</span
                        >
                      </v-flex>
                      <v-flex xs12>
                        <span
                          style="
                            font-family: sofialight;
                            font-size: 12px;
                            color: #7b7b7b;
                          "
                          >Please enter OTP sent to your Mobile
                        </span>
                      </v-flex>
                      <v-flex xs11 sm11 lg8 xl5 pt-8 pl-4 pl-lg-2 text-center>
                        <vie-otp-input
                          inputClasses="otp-input"
                          :numInputs="4"
                          separator
                          :shouldAutoFocus="true"
                          @on-complete="validateOTP"
                        />
                      </v-flex>
                      <v-flex xs12 pt-9>
                        <v-btn
                          block
                          color="#E31E24"
                          dark
                          :ripple="false"
                          depressed
                          @click="validateInput"
                        >
                          <span
                            style="
                              font-family: sofialight;
                              font-size: 12px;
                              text-transform: none;
                            "
                            >Continue</span
                          >
                        </v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs12 text-center>
                            <span
                              style="
                                font-family: sofialight;
                                font-size: 12px;
                                color: #7b7b7b;
                              "
                              >Didn't receive code? &nbsp;</span
                            >

                            <span
                              v-if="!otpexpired"
                              style="
                                font-family: sofialight;
                                font-size: 12px;
                                color: #393c4a;
                              "
                              >Please Wait {{ timeLeft }}</span
                            >
                            <span
                              v-if="otpexpired"
                              style="
                                font-family: sofialight;
                                font-size: 12px;
                                color: #393c4a;
                                cursor: pointer;
                              "
                              @click="sentOTP"
                              >Resent</span
                            >
                          </v-flex>
                        </v-layout>
                        <v-layout v-if="msg2" py-4 wrap>
                          <v-flex text-center>
                            <span
                              style="
                                font-family: poppinslight;
                                font-size: 14px;
                                color: red;
                              "
                              >{{ msg2 }}</span
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex py-12>
                        <span style="color: #fff">.</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app>
  </div>
</template>
<script>
import VieOtpInput from "@bachdgvn/vue-otp-input";
import axios from "axios";
export default {
  components: {
    VieOtpInput,
  },
  props: ["pageData", "lastPage", "backgroundImage"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      msg2: null,
      phone: null,
      otp: null,
      timeLeft: "00:00",
      intervalTimer: null,
      otpexpired: false,
    };
  },
  beforeMount() {
    this.setTime(180);
    this.phone = this.pageData.phone;
  },
  methods: {
    validateOTP(value) {
      this.otp = value;
      this.validateInput();
    },
    validateInput() {
      this.login();
      // this.$emit("stepper", {
      //   winStep: 0,
      // });
    },
    login() {
      this.appLoading = true;
      var userData = {};
      userData["phone"] = this.pageData.phone;
      userData["otp"] = this.otp;
      axios({
        method: "POST",
        url: "user/signup/signin",
        data: {
          accessType: "signin",
          phone: this.pageData.phone,
          otp: this.otp,
          role: "seller",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (response.data.role !== "customer") {
              localStorage.setItem("token", response.data.token);
              localStorage.setItem("userid", response.data.data._id);
              // this.$store.commit("changeCart", response.data.data.cartcount);
              // this.$store.commit("changeWishlist", response.data.data.wishlistcount);
              this.$store.commit("userDetailed", response.data);
              this.$store.commit("loginUser", response.data.status);
              this.$store.commit("userType", response.data.role);
              // this.$store.commit(
              //   "userSubCategory",
              //   response.data.data.sellerid.subcategory
              // );

              // console.log("Fined check status=",response.data.profileStatus)
              if (response.data.profileStatus == "incomplete") {
                this.$store.commit("registrationStage", response.data.level);
                this.$router.push("/completeRegistration");
              }
              if (response.data.profileStatus == "pending") {
                this.$store.commit("registrationStage", response.data.level);
                this.$store.commit(
                  "userSubCategory",
                  response.data.data.sellerid.subcategory
                );
                this.$router.push("/completeRegistration");
              }

              if (response.data.profileStatus == "active") {
                this.$store.commit("userData", response.data.data.sellerid);
                this.$store.commit(
                  "userCategory",
                  response.data.data.sellerid.category[0]
                );
                this.$store.commit(
                  "userSubCategory",
                  response.data.data.sellerid.subcategory
                );
                this.$router.push("/Seller");
              }
              if (response.data.profileStatus == "reject") {
                this.$store.commit("userData", response.data.data.sellerid);
                this.$store.commit(
                  "userCategory",
                  response.data.data.sellerid.category[0]
                );
                this.$store.commit(
                  "userSubCategory",
                  response.data.data.sellerid.subcategory
                );
                this.$router.push("/sellerStatus");
              }
            } else {
              this.msg2 =
                "You try to login to seller account with your Customer account. Please try again with other number";
            }
            // if (localStorage.getItem("routeKey") && response.data.data.type == "Client") {

            //   this.$router.push(localStorage.getItem("routeKey"));
            // }
            //  else if (response.data.data.type == "Seller") {
            //   if (
            //     response.data.data.status == "Pending" &&
            //     response.data.userdata.seller.accountnumber == undefined
            //   ) {
            //     this.$router.push("/sellerRegistration");
            //   } else if (
            //     response.data.data.status == "Pending" &&
            //     response.data.userdata.seller.accountnumber != null
            //   ) {
            //     this.$router.push({ name: "sellerStatus" });
            //   } else if (response.data.data.status == "Rejected") {
            //     this.$router.push({ name: "sellerStatus" });
            //   } else {
            //     this.$router.push("/Seller");
            //   }
            // } else if (response.data.data.type == "Client") {
            //   this.$router.push("/");
            // } else {
            //   this.$router.push("/");
            // }
          } else {
            this.msg2 = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    sentOTP() {
      var userData = {};
      userData["phone"] = this.pageData.phone;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/getsms",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.setTime(180);
            this.otpexpired = false;
            this.msg = "OTP Sent Successfully";
            this.showSnackBar = true;
          } else {
            this.msg = "Something Went Wrong";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);
      this.countdown(end);
    },
    countdown(end) {
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);
        if (secondsLeft == 0) this.otpexpired = true;
        if (secondsLeft < 0) {
          clearInterval(this.intervalTimer);
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      var seconds1 = seconds;
      if (seconds < 10) seconds1 = "0" + seconds;
      this.timeLeft = "0" + minutes + " : " + seconds1;
    },
  },
};
</script>
